import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cancel-button',
    templateUrl: './cancel-button.component.html',
    styleUrls: ['./cancel-button.component.scss'],
    standalone: false
})
export class CancelButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
